import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import { cn } from '@dc-shared-web/lib'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, side = 'bottom', ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    side={side}
    className={cn(
      'tw-z-50 tw-text-background tw-rounded-md tw-bg-foreground tw-px-3 tw-py-1.5 tw-text-2xs tw-shadow-md data-[state=delayed-open]:tw-animate-in data-[state=delayed-open]:tw-fade-in-0 data-[state=delayed-open]:tw-zoom-in-95 data-[state=delayed-open]:data-[state=closed]:tw-animate-out data-[state=delayed-open]:data-[state=closed]:tw-fade-out-0 data-[state=delayed-open]:data-[state=closed]:tw-zoom-out-95 data-[state=delayed-open]:data-[side=bottom]:tw-slide-in-from-top-2 data-[state=delayed-open]:data-[side=left]:tw-slide-in-from-right-2 data-[state=delayed-open]:data-[side=right]:tw-slide-in-from-left-2 data-[state=delayed-open]:data-[side=top]:tw-slide-in-from-bottom-2',
      className
    )}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

const TooltipArrow = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Arrow>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Arrow>
>(({ className, ...props }, ref) => (
  <TooltipPrimitive.Arrow ref={ref} className={className} {...props} />
))
TooltipArrow.displayName = TooltipPrimitive.Arrow.displayName

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TooltipArrow,
}
